import React from 'react';
import * as PropTypes from 'prop-types';

const JobTitleClusterFooter = (props) => {
  const { linksData, TitleTagName = 'h3' } = props;
  return (
    <div className="row job-title-cluster-footer">
      {linksData.map(({ title, links }) => {
        if (!links?.length) return null;
        return (
          <div className={`col-12 col-lg-3 mt-4`}>
            <TitleTagName className="footer-link-list-title">{title}</TitleTagName>
            <ul className="footer-link-list">
              {links.map(({ rel, link, text, title }, index) => (
                <li key={index} className={`footer-link-list-item`}>
                  <a rel={rel} href={link} title={title}>
                    {text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

JobTitleClusterFooter.propTypes = {
  linksData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      links: PropTypes.array.isRequired,
    })
  ),
  totalColumnsInRow: PropTypes.number,
};

JobTitleClusterFooter.defaultProps = {
  linksData: [],
  totalColumnsInRow: 4,
};

export default JobTitleClusterFooter;
